import React from "react";
import { cn } from "../../../../lib/utils";
import { InvoiceActionButton } from "./InvoiceActionButton";
import { TABLE_COLUMNS } from "./TableHeader";

export const InvoiceTableRow = ({ invoice, isDownloading, downloadingInvoiceId, onDownload, onPay }) => {

  return (
    <tr className="hover:bg-gray-50 dark:hover:bg-gray-800/30 transition-colors duration-150">
      {TABLE_COLUMNS.map((column) => {
        const value = invoice[column.key];
        const { className, content } = column.render(value);

        return (
          <td key={`${invoice.id}-${column.key}`} className={cn("px-6 py-4", className)}>
            {content}
          </td>
        );
      })}
      <td className="px-6 py-4 flex justify-end items-center gap-2">
        <InvoiceActionButton
          invoice={invoice}
          isDownloading={isDownloading}
          downloadingInvoiceId={downloadingInvoiceId}
          onDownload={onDownload}
          onPay={onPay}
        />
      </td>
    </tr>
  );
};
